export default "__VITE_ASSET__BijfZ1cB__"